import React, { useState, useEffect } from "react";

import heroImg from "../../../assets/slider-111.png";
import commercialVideo from "../../../assets/vid1.mp4";
import commercialProductImg1 from "../../../assets/purepower-commercial-product30.png";
import commercialProductImg2 from "../../../assets/purepower-commercial-product60.png";
import commercialProductImg3 from "../../../assets/purepower-commercial-product120.png";

import bottomBanner from "../../../assets/purepower-commercial-bottom.webp";
import KeyFeature1 from "../../../assets/key-feature-com-1.png";
import KeyFeature2 from "../../../assets/key-feature-com-2.png";
import KeyFeature3 from "../../../assets/key-feature-com-3.png";
import KeyFeature4 from "../../../assets/key-feature-com-4.png";
import KeyFeature5 from "../../../assets/key-feature-com-5.png";
import KeyFeature6 from "../../../assets/key-feature-com-6.png";
import KeyFeature7 from "../../../assets/key-feature-com-7.png";
import KeyFeature8 from "../../../assets/key-feature-com-8.png";
import KeyFeature9 from "../../../assets/key-feature-com-9.png";
import KeyFeature10 from "../../../assets/key-feature-com-10.png";
import KeyFeature11 from "../../../assets/key-feature-com-11.png";
import KeyFeature12 from "../../../assets/key-feature-com-12.png";
import KeyFeature13 from "../../../assets/key-feature-com-13.png";
import KeyFeature14 from "../../../assets/key-feature-com-14.png";
import KeyFeature15 from "../../../assets/key-feature-com-15.png";


// DATA
const commercialProducts = [
  {
    Name: "Ace - 30 kVA",

    RatedPower: "30000 W",

    Input: {
      Voltage: "3×415 VAC",
      SelectableVoltage: "380–440 VAC",
      Frequency: "50/60 Hz Auto",
    },

    Output: {
      AcVoltage: "415 VAC ±5%",
      SurgePower: "60000 VA",
      Efficiency: "~94%",
      Switching: "On/Off Grid/Hybrid",
      Transfer: "10 ms",
      Waveform: "Pure sine wave",
    },

    Solar: {
      Charger: "MPPT",
      Mppt: "6",
      PvVoltage: "450 VDC",
      PvPower: "6×7500 W",
      PvCurrent: "6×27 A",
      MppRange: "60–450 VDC",
      SolarCharge: "450 A",
      AcCharge: "450 A",
    },

    Battery: {
      Technology: "Lithium Ion",
      Qty: "7",
      Voltage: "48 V",
      Capacity: "30 kWh",
      Charge: "150 A",
      Discharge: "90A×7",
      FullCharge: "54.3 V",
      FullDischarge: "40 V",
    },

    Protection: {
      Bms: "5th Gen BMS",
      Ip: "IP65",
      Anti: "Integrated",
      Ac: "Integrated",
      Short: "Integrated",
      Overload: "Integrated",
      Temp: "Integrated",
      Fan: "Integrated",
    },

    General: {
      Dimensions: "756×633×1620",
      Installation: "Floor standing",
      Weight: "345±5 kg",
      Warranty: "5 years",
      Extended: "12 years",
      Noise: "-",
      Thermal: "Nano PCM",
      Communication: "BT, WiFi, AI Cloud",
    },
  },

  {
    Name: "Rise - 60 kVA",

    RatedPower: "60000 W",

    Input: {
      Voltage: "3×415 VAC",
      SelectableVoltage: "380–440 VAC",
      Frequency: "50/60 Hz Auto",
    },

    Output: {
      AcVoltage: "415 VAC ±5%",
      SurgePower: "120000 VA",
      Efficiency: "~94%",
      Switching: "On/Off Grid/Hybrid",
      Transfer: "10 ms",
      Waveform: "Pure sine wave",
    },

    Solar: {
      Charger: "MPPT",
      Mppt: "12",
      PvVoltage: "450 VDC",
      PvPower: "12×5500 W",
      PvCurrent: "12×18 A",
      MppRange: "90–450 VDC",
      SolarCharge: "450 A",
      AcCharge: "450 A",
    },

    Battery: {
      Technology: "Lithium Ion",
      Qty: "14",
      Voltage: "48 V",
      Capacity: "60 kWh",
      Charge: "150 A",
      Discharge: "90A×14",
      FullCharge: "54.3 V",
      FullDischarge: "40 V",
    },

    Protection: {
      Bms: "5th Gen BMS",
      Ip: "IP65",
      Anti: "Integrated",
      Ac: "Integrated",
      Short: "Integrated",
      Overload: "Integrated",
      Temp: "Integrated",
      Fan: "Integrated",
    },

    General: {
      Dimensions: "820×1155×1450",
      Installation: "Floor standing",
      Weight: "690±5 kg",
      Warranty: "5 years",
      Extended: "12 years",
      Noise: "<50 dB",
      Thermal: "Nano PCM",
      Communication: "BT, WiFi, AI Cloud",
    },
  },

  {
    Name: "Octane - 120 kVA",

    RatedPower: "120000 W",

    Input: {
      Voltage: "3×415 VAC",
      SelectableVoltage: "380–440 VAC",
      Frequency: "50/60 Hz Auto",
    },

    Output: {
      AcVoltage: "415 VAC ±5%",
      SurgePower: "240000 VA",
      Efficiency: "~94%",
      Switching: "On/Off Grid/Hybrid",
      Transfer: "10 ms",
      Waveform: "Pure sine wave",
    },

    Solar: {
      Charger: "MPPT",
      Mppt: "24",
      PvVoltage: "450 VDC",
      PvPower: "24×5500 W",
      PvCurrent: "24×18 A",
      MppRange: "90–450 VDC",
      SolarCharge: "900 A",
      AcCharge: "900 A",
    },

    Battery: {
      Technology: "Lithium Ion",
      Qty: "28",
      Voltage: "48 V",
      Capacity: "120 kWh",
      Charge: "300 A",
      Discharge: "90A×28",
      FullCharge: "54.3 V",
      FullDischarge: "40 V",
    },

    Protection: {
      Bms: "5th Gen BMS",
      Ip: "IP65",
      Anti: "Integrated",
      Ac: "Integrated",
      Short: "Integrated",
      Overload: "Integrated",
      Temp: "Integrated",
      Fan: "Integrated",
    },

    General: {
      Dimensions: "1270×1630×3050",
      Installation: "Floor standing",
      Weight: "1300±10 kg",
      Warranty: "5 years",
      Extended: "12 years",
      Noise: "<50 dB",
      Thermal: "Nano PCM",
      Communication: "BT, WiFi, AI Cloud",
    },
  },
];

const SpecCard = ({ title, data }) => (
  <div
    className="
      rounded-3xl
      overflow-hidden
      bg-gradient-to-br
      from-[#2a2a2a]
      via-[#252525]
      to-[#1c1c1c]
      border border-[#3a3a3a]
      shadow-[0_15px_40px_rgba(0,0,0,0.35)]
      hover:border-[#F5B13C]
      hover:-translate-y-1
      hover:shadow-[0_20px_50px_rgba(245,177,60,0.18)]
      transition-all
      duration-300
    "
  >
    {/* Header */}
    <div className="bg-black border-b border-[#F5B13C]/30 px-6 py-5">

      <h3 className="uppercase tracking-[4px] text-sm font-bold text-[#F5B13C]">
        {title}
      </h3>

    </div>

    {/* Body */}
    <div className="max-h-[280px] overflow-y-auto custom-scroll">

      {Object.entries(data).map(([key, value], index) => (

        <div
          key={key}
          className={`
            flex
            justify-between
            items-center
            gap-6
            px-6
            py-4
            border-b
            border-white/10
            transition
            duration-200

            ${
              index % 2 === 0
                ? "bg-white/[0.02]"
                : "bg-transparent"
            }

            hover:bg-[#F5B13C]/10
          `}
        >

          <span className="text-gray-300 font-medium">
            {key.replace(/([A-Z])/g, " $1")}
          </span>

          <span className="text-white font-semibold text-right">
            {value}
          </span>

        </div>

      ))}

    </div>
  </div>
);

// COMPONENT
const PurePowerCommercial = () => {

  // STATE MUST BE INSIDE COMPONENT
  const [
    activeCommercial,
    setActiveCommercial,
  ] = useState(0);

  // CURRENT PRODUCT
  const activeProduct =
    commercialProducts[
      activeCommercial
    ];

    const keyFeatures = [
    KeyFeature1,
    KeyFeature2,
    KeyFeature3,
    KeyFeature4,
    KeyFeature5,
    KeyFeature6,
    KeyFeature7,
    KeyFeature8,
    KeyFeature9,
    KeyFeature10,
    KeyFeature11,
    KeyFeature12,
    KeyFeature13,
    KeyFeature14,
    KeyFeature15,
    ];

const commercialImages = [
  commercialProductImg1,
  commercialProductImg2,
  commercialProductImg3,
];

const [currentImage, setCurrentImage] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentImage((prev) => (prev + 1) % commercialImages.length);
  }, 3000);

  return () => clearInterval(interval);
}, []);

  return (
    <div>
        <section className="bg-black">
            {/* Hero Section */}
            <div className="relative min-h-screen sm:h-screen bg-cover bg-center flex items-center" style={{ backgroundImage: `url(${heroImg})` }}>
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/35" />

                {/* Content */}
                <div className="relative z-10 px-4 sm:px-8 md:px-24 max-w-[700px] py-12 sm:py-0">
                    <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold leading-tight">
                        Powered for Growth
                    </h1>
                    <p className="mt-4 sm:mt-8 text-white text-base sm:text-lg md:text-xl lg:text-3xl leading-relaxed">
                        Scalable and efficient energy storage products for your
                        commercial success. Tailored for every business size
                    </p>
                </div>
            </div>
        </section>

        {/* Why PuREPower Commercial */}
        <section className="bg-[#f4f4f4] py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-14">
            <div className="max-w-[1500px] mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-14 items-center">
                    {/* LEFT CONTENT */}
                    <div>
                        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-semibold text-[#1B2230] leading-tight">
                            Why PuREPower Commercial?
                        </h2>
                        <p className="mt-6 sm:mt-8 md:mt-10 text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed sm:leading-[1.8] md:leading-[2.1] text-[#1B2230]">
                            Slash peak load charges, maximize solar efficiency,
                            and forget about maintenance.
                            Store energy smartly, reduce diesel consumption,
                            use it powerfully, and enjoy a long-lasting warranty.
                            More than energy storage — it’s a strategic
                            advantage for your business.
                        </p>
                    </div>

                    {/* RIGHT VIDEO */}
                    <div className="rounded-2xl sm:rounded-3xl lg:rounded-[32px] overflow-hidden shadow-lg">
                        <video autoPlay muted loop playsInline className="w-full h-[300px] sm:h-[400px] md:h-[500px] object-cover">
                            <source
                                src={commercialVideo}
                                type="video/mp4"
                            />
                        </video>
                    </div>
                </div>
            </div>
        </section>

        {/* PuREPower Commercial Section */}
        <section className="bg-[#f5f5f5] py-12 sm:py-16 md:py-24 px-4 sm:px-6">
            <div className="max-w-[1400px] mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-[55%_45%] gap-8 sm:gap-12 md:gap-20 items-center">
                    {/* LEFT IMAGE */}
                    <div className="bg-white rounded-3xl p-8 md:p-10">

                      {/* Image */}
                      <div className="relative w-full max-w-[500px] h-[500px] mx-auto">

                        {commercialImages.map((image, index) => (
                          <img
                            key={index}
                            src={image}
                            alt={`Commercial ${index + 1}`}
                            className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ${
                              currentImage === index ? "opacity-100" : "opacity-0"
                            }`}
                          />
                        ))}

                      </div>

                      {/* Dots */}
                      <div className="flex justify-center items-center gap-3 mt-6">
                        {commercialImages.map((_, index) => (
                          <button
                            key={index}
                            onClick={() => setCurrentImage(index)}
                            aria-label={`Go to slide ${index + 1}`}
                            className={`transition-all duration-300 rounded-full ${
                              currentImage === index
                                ? "w-8 h-3 bg-[#F5B13C]"
                                : "w-3 h-3 bg-gray-300 hover:bg-gray-400"
                            }`}
                          />
                        ))}
                      </div>

                    </div>

                    {/* RIGHT CONTENT */}
                    <div>
                        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-[42px] font-light text-[#1a1a1a]">
                            PuREPower Commercial
                        </h2>
                        <ul className="mt-6 sm:mt-8 md:mt-10 space-y-4 sm:space-y-5 md:space-y-6 text-lg sm:text-xl md:text-2xl lg:text-[24px] text-[#1a1a1a]">
                            <li>• 30.0</li>
                            <li>• 60.0</li>
                            <li>• 120.0</li>
                        </ul>
                        <a
                            href="https://wa.me/919944211899?text=Hello%20I%27m%20interested%20in%20PuREPower%20Commercial"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-8 sm:mt-10 md:mt-12 px-8 sm:px-10 py-2 sm:py-3 border border-[#F5B13C] rounded-full text-[#F5B13C] text-base sm:text-lg md:text-xl hover:bg-[#F5B13C] hover:text-black transition inline-block text-center"
                        >
                            Learn More
                        </a>
                    </div>
                </div>
            </div>
        </section>

        {/* Bottom Image Section */}
        <section className="bg-[#f5f5f5] px-4 sm:px-6 pb-8 sm:pb-16 md:pb-16">
            <div className="max-w-[1500px] mx-auto">
                <div className="overflow-hidden rounded-2xl sm:rounded-3xl lg:rounded-[32px]">
                    <img src={bottomBanner} alt="PuREPower Commercial" className="w-full h-auto object-cover hover:scale-[1.02] transition duration-700" />
                </div>
            </div>
            <div className="max-w-[1200px] mt-6 sm:mt-8 md:mt-8 mx-auto text-center px-4">
                <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-semibold text-[#1a1a1a]">
                    Industries We Power
                </h1>

                <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold text-[#3c3c3c] mt-4 sm:mt-6">
                    Powering Every Sector Reliably
                </h2>
                <p className="mt-2 text-sm sm:text-base md:text-lg lg:text-[24px] text-[#3c3c3c] leading-relaxed">
                    PuREPower Commercial adapts to diverse industries:
                    uninterrupted power for offices, critical backup for
                    hospitals, building revenues for EV Charging Stations,
                    seamless operations for retail and hospitality, and
                    reliable support for telecom and communities.
                    Tailored solutions empower businesses across all sectors.
                </p>
            </div>
        </section>

        <section className="bg-[#f5f5f5] text-white py-8 sm:py-16 md:py-24 px-4 sm:px-6">
            <div className="max-w-[1450px] mx-auto">
                <p className="text-green-600 font-semibold uppercase tracking-[0.35em] text-xs sm:text-sm">
                    Technical Details
                </p>
                <h2 className="text-2xl sm:text-3xl md:text-5xl text-black font-bold mt-3">
                    PuREPower Commercial Specifications
                </h2>
                {/* Tabs */}
                <div className="mt-8 sm:mt-10 flex flex-wrap gap-2 sm:gap-3 md:gap-4">
                    {commercialProducts.map((product, index) => (
                        <button
                        key={index}
                        onClick={() => setActiveCommercial(index)}
                        className={`px-4 sm:px-6 py-2 sm:py-3 rounded-full transition text-xs sm:text-sm md:text-base ${
                            activeCommercial === index
                            ? "bg-[#F5B13C] text-black"
                            : "bg-[#303030]"
                        }`}
                        >
                        {product.Name}
                        </button>
                    ))}
                </div>

                {/* Table */}
                <div className="mt-10 sm:mt-14">

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">

                        <SpecCard
                            title="Input"
                            data={activeProduct.Input}
                        />

                        <SpecCard
                            title="Output"
                            data={activeProduct.Output}
                        />

                        <SpecCard
                            title="Solar Charger"
                            data={activeProduct.Solar}
                        />

                        <SpecCard
                            title="Battery"
                            data={activeProduct.Battery}
                        />

                        <SpecCard
                            title="Protection"
                            data={activeProduct.Protection}
                        />

                        <SpecCard
                            title="General"
                            data={activeProduct.General}
                        />

                    </div>

                </div>
            </div>
        </section>

        <section className="bg-[#f5f5f5] py-12 sm:py-16 md:py-24 px-4 sm:px-6">

            <div className="max-w-[1450px] mx-auto">

                <p className="text-green-600 font-semibold uppercase tracking-[0.35em] text-xs sm:text-sm">
                    Key Features
                </p>

                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 sm:gap-3 md:gap-4 lg:gap-6 mt-8 sm:mt-10 md:mt-14">

                    {keyFeatures.map((image, index) => (

                        <div
                            key={index}
                            className="
                                overflow-hidden
                                rounded-lg sm:rounded-xl md:rounded-2xl
                                shadow-md
                                hover:shadow-xl
                                transition-all
                                duration-300
                                group
                            "
                        >

                            <img
                                src={image}
                                alt={`Key Feature ${index + 1}`}
                                className="
                                    w-full
                                    h-full
                                    object-cover
                                    group-hover:scale-105
                                    transition-transform
                                    duration-500
                                "
                            />

                        </div>

                    ))}

                </div>

            </div>

        </section>

    </div>
  );
};

export default PurePowerCommercial;